import { createFileRoute, Outlet } from '@tanstack/react-router';
import Navbar from 'components/Navbar/Navbar.component';

export const Route = createFileRoute('/_layout_with_navbar')({
  component: LayoutWithNavbar,
});

function LayoutWithNavbar() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}
